export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40 pointer-events-none"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase text-primary-600 bg-primary-100/80 rounded-full mb-5">
              全网黑料资源一站聚合
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              黑料官网
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-1">
                黑料网站资源导航与内容聚合平台
              </span>
            </h1>

            <p className="text-sm font-medium text-foreground-700 mt-2">
              发现优质黑料内容，从这里开始
            </p>

            <p className="text-base md:text-lg text-foreground-700 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mt-5">
              黑料官网致力于为您提供最全面、最可靠的黑料网站导航服务。从91黑料在线到51黑料在线，从热门社区到新兴站点，我们精心筛选并整理全网优质黑料内容资源。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mt-3">
              每日更新站点状态与内容索引，确保每一条黑料在线导航都准确有效。无论你是想快速浏览当日热点，还是深入探索特定话题，这里都能为你提供清晰的黑料网导航路径。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-7">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>收录站点 <strong className="text-foreground-900">200+</strong></span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>每日<strong className="text-foreground-900">更新精选</strong></span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span><strong className="text-foreground-900">安全可靠</strong>访问</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line"></i>
                浏览排行
              </a>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 border border-foreground-300 text-foreground-700 font-semibold text-sm rounded-lg hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-newspaper-line"></i>
                最新动态
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20bold%20dramatic%20editorial%20composition%20with%20deep%20charcoal%20and%20warm%20crimson%20tones%2C%20abstract%20newspaper%20collage%20with%20modern%20graphic%20design%20elements%2C%20dynamic%20diagonal%20composition%2C%20mysterious%20spotlight%20effect%2C%20high%20contrast%20editorial%20photography%2C%20sophisticated%20magazine%20aesthetic%2C%20textured%20overlay%2C%20dramatic%20atmosphere&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="黑料官网首页主视觉 - 黑料网站导航与内容聚合"
                className="w-full h-full object-cover object-top"
                onError={(e) => { e.currentTarget.parentElement!.style.display = 'none'; }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}